import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function fetchDataColumns(state = initialState.dataColumns, action) {
  switch (action.type) {
    case types.FETCH_DATA_COLUMNS:
      return {
        ...state,
        columns: [...action?.columns],
        pageId: action.pageId,
      };
    default:
      return state;
  }
}
